import { HookFormCheckbox, SubmitButton, TextInput } from "../../../hook-form";
import { SectionHeader, SwitchAppButton } from "../../../components";

import { IOnboardingStepViewProps } from "../Onboarding";
import { IOnboardingStep4Request } from "../../../interfaces-and-types";
import { OnboardingCheckboxWithTitle } from "./OnboardingCheckboxWithTitle";

export const View = ({
  isActive,
  errors: errors,
  handlePrevious,
  handleSubmit: handleSubmit,
  register: register,
}: IOnboardingStepViewProps<IOnboardingStep4Request>) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className="onboarding-section">
        <SectionHeader
          title="Secure your account."
          subtitle="SwitchApp helps its users secure their account, using either your phone, email or an authenticator app, in addition to your password, it ensure you that no one else can log in to your account, or make any transactions."
        />

        {/* <h5 className="form-section--title font-ctm--bold">
          Two-Step Authentication
        </h5>

        <OnboardingCheckboxWithTitle
          name="two_factor_login_enabled_for_superadmin"
          title="Two-factor authentication for admin login"
          label="Require 2FA every time you login."
          register={register}
          errors={errors}
          disabled={!isActive}
        />

        <OnboardingCheckboxWithTitle
          name="two_factor_login_enabled_for_all_staff"
          title="Two-factor authentication for all staff logins"
          label="Require 2FA every time memebers of staff login."
          register={register}
          errors={errors}
          disabled={!isActive}
        /> */}

        <OnboardingCheckboxWithTitle
          name="send_otp_to_email_only"
          title="Send OTP to my email only."
          register={register}
          errors={errors}
          disabled={!isActive}
        />

        {/* <OnboardingCheckboxWithTitle
          name="use_authenticator_app"
          title="Use an Authenticator app"
          register={register}
          errors={errors}
          disabled={!isActive}
        /> */}

        <OnboardingCheckboxWithTitle
          name="two_factor_transfers_enabled"
          title="Two factor authentication for transfers"
          label={
            "Require a PIN or get an OTP via SMS & Email every time a transfer is initiated."
          }
          register={register}
          errors={errors}
          disabled={!isActive}
        />

        <div className="flex-container buttons-container">
          {!isActive ? null : (
            <SwitchAppButton
              className="onboarding-previous--button"
              kind="secondary"
              onClick={handlePrevious}
            >
              Previous
            </SwitchAppButton>
          )}

          {!isActive ? null : (
            <SubmitButton className="onboarding-submit--button">
              Continue
            </SubmitButton>
          )}
        </div>
      </div>
    </form>
  );
};
